import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-unsubscribed',
  templateUrl: './unsubscribed.component.html',
  styleUrls: ['./unsubscribed.component.scss'],
})
export class UnsubscribedComponent implements OnInit, OnDestroy {
  constructor(@Inject(DOCUMENT) private document: Document) {
    this.document.body.classList.add('dark-theme');
    this.document.body.classList.add('unsubscribed');
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.document.body.classList.remove('dark-theme');
    this.document.body.classList.remove('unsubscribed');
  }
}
